"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var uaParserJs = require('ua-parser-js');

var _isMobile = require('is-mobile');

var EcosiaCookie = require('./ecosia-cookie');

var _require = require('./config'),
    customUserAgentMap = _require.customUserAgentMap,
    supportedLanguages = _require.supportedLanguages,
    DEFAULT_LANGUAGE = _require.DEFAULT_LANGUAGE,
    deviceTypeMap = _require.deviceTypeMap;

var getBrowserName = function getBrowserName(detectedName, osName, userAgent) {
  var custom = Object.keys(customUserAgentMap).find(function (name) {
    return customUserAgentMap[name].test(userAgent);
  });

  if (custom) {
    return custom;
  }

  if (['Android', 'iOS'].includes(osName)) {
    return osName;
  }

  return detectedName;
}; // Get the browser name, version and device type from user-agent


var getBrowser = function getBrowser(userAgent) {
  var _uaParserJs = uaParserJs(userAgent),
      browser = _uaParserJs.browser,
      os = _uaParserJs.os,
      device = _uaParserJs.device; // at this point, browser `name` and `version` can be falsy, possibly due to uaParserJs that sets them as such
  // if user agent is empty, incomplete or invalid; so we default them to empty string for safety


  return {
    name: getBrowserName(browser.name, os.name, userAgent) || '',
    version: browser.version || '',
    // ua-parser-js does not set device type if the device is a desktop computer
    // this is on purpose, see: https://github.com/faisalman/ua-parser-js/issues/308
    deviceType: deviceTypeMap[device.type] || deviceTypeMap.default
  };
}; // Parse the raw Accept-Language header, returning only the ISO 639-1 code.
// For example: da, en-gb;q=0.8, en;q=0.7 should return "da"


var parseAcceptLanguage = function parseAcceptLanguage(acceptLanguage) {
  if (acceptLanguage === undefined || acceptLanguage.length === 0) {
    return undefined;
  }

  var reg = /([a-z]+-?)(?!=)/gi;
  var matches = reg.exec(acceptLanguage);

  if (matches === null || matches.length === 0) {
    return undefined;
  }

  var lang = matches[0]; // If we have a language-region combination (such as en-gb), return only
  // the language.

  return lang.replace('-', '');
}; // Validate language


var isValidLanguage = function isValidLanguage(language) {
  return supportedLanguages.includes(language);
};

var EcosiaUser = /*#__PURE__*/function () {
  function EcosiaUser() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EcosiaUser);

    this.settings = _objectSpread({
      cookieString: '',
      defaultLanguage: DEFAULT_LANGUAGE,
      userAgent: ''
    }, options);
    this.cookie = '';
    this.ecosiaCookie = new EcosiaCookie({
      cookieString: this.settings.cookieString
    });
    this.attributes = this.ecosiaCookie.mapAttributesWithCookie();
    this.setBrowserAttributes();
    this.setInitialLanguage();
    return this;
  }

  _createClass(EcosiaUser, [{
    key: "get",
    value: function get(attr) {
      return attr ? this.attributes[attr] : this.attributes;
    }
  }, {
    key: "has",
    value: function has(attr) {
      return attr in this.attributes;
    }
  }, {
    key: "set",
    value: function set(attr, value) {
      if (attr === 'language' && !isValidLanguage(value)) {
        // eslint-disable-next-line no-param-reassign
        value = this.settings.defaultLanguage;
      }

      this.attributes[attr] = value;
      return this.ecosiaCookie.setCookieValue(attr, value);
    }
  }, {
    key: "setBrowserAttributes",
    value: function setBrowserAttributes() {
      var _getBrowser = getBrowser(this.settings.userAgent),
          name = _getBrowser.name,
          version = _getBrowser.version,
          deviceType = _getBrowser.deviceType;

      this.set('browser', name.toLowerCase());
      this.set('browserDisplay', name);
      this.set('browserVersion', version);
      this.set('defaultMarket', this.ecosiaCookie.defaultCookie.mc);
      this.set('deviceType', deviceType);
    } // if the language stored in cookie is empty or invalid, parse the language from accept-language
    // header and set it as new language

  }, {
    key: "setInitialLanguage",
    value: function setInitialLanguage() {
      var language = this.get('language');

      if (!isValidLanguage(language)) {
        var parsed = parseAcceptLanguage(this.settings.acceptLanguage);
        this.set('language', parsed);
      }
    }
  }, {
    key: "unset",
    value: function unset(key) {
      delete this.attributes[key];
    }
  }, {
    key: "hasAddOn",
    value: function hasAddOn() {
      return this.get('addOn') === 1;
    }
    /* eslint-disable class-methods-use-this */

  }, {
    key: "cookiesEnabled",
    value: function cookiesEnabled() {
      return typeof navigator !== 'undefined' && navigator.cookieEnabled;
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return !('callPhantom' in window) && _isMobile();
    }
  }, {
    key: "isFirstVisit",
    value: function isFirstVisit() {
      return this.get('treeCount') === 0;
    }
  }, {
    key: "isFirstSearch",
    value: function isFirstSearch() {
      return this.get('firstSearch') === 1 && this.get('treeCount') === 1;
    }
  }, {
    key: "isRetina",
    value: function isRetina() {
      return window.devicePixelRatio > 1 || false;
    }
    /* eslint-enable class-methods-use-this */

  }, {
    key: "getStringifiedCookieValue",
    value: function getStringifiedCookieValue() {
      return EcosiaCookie.stringify(this.ecosiaCookie.cookie);
    }
  }, {
    key: "setFlowStage",
    value: function setFlowStage() {
      if (this.isFirstVisit()) {
        this.set('flowStage', 'firstVisit');
      } else if (this.isFirstSearch()) {
        this.set('flowStage', 'firstSearch');
        this.ecosiaCookie.setCookieValue(this.cookie, 'fs', '0');
      } else if (this.get('firstRun') === 1) {
        this.set('flowStage', 'firstPostInstallSearch');
      } else {
        this.set('flowStage', 'subsequentVisit');
      }
    }
  }]);

  return EcosiaUser;
}();

module.exports = EcosiaUser;